	import { gsap} from 'gsap';
	import { Draggable } from 'gsap/Draggable';

	gsap.registerPlugin(Draggable);
	export default class Drag {

	constructor() {
		this.init();
	}

	init() {
		let xPos = 0;
		let ringAnimation = gsap.timeline();

		gsap.timeline()
			.set(dragger, { opacity: 0 }) //make the drag layer invisible
			.set(ring, { rotationY: 180 }) //set initial rotationY so the parallax jump happens off-screen
			.set('.img', {
				// apply transform rotations to each image
				rotateY: (i) => i * -36,
				transformOrigin: '50% 50% 1400px',
				z: -1400,
				// y: 100, // add this line
				backgroundPosition: (i) => getBgPos(i),
				backfaceVisibility: 'hidden',
			 })

		ringAnimation.to(ring, {
			duration: 1000,
			rotationY: 4000,
		});

		Draggable.create(dragger, {
			onDragStart: (e) => {
				if (e.touches) e.clientX = e.touches[0].clientX;
				xPos = Math.round(e.clientX);
				ringAnimation.pause(); // pause the ring animation on drag start
			},

			onDrag: (e) => {
				if (e.touches) e.clientX = e.touches[0].clientX;

				gsap.to(ring, {
				rotationY: '-=' + ((Math.round(e.clientX) - xPos) % 360),
				onUpdate: () => {
					gsap.set('.img', { backgroundPosition: (i) => getBgPos(i) });
				},
				});

				xPos = Math.round(e.clientX);
			},

			onDragEnd: (e) => {
				gsap.set(dragger, { x: 0, y: 0 }); // reset drag layer
			   // ringAnimation.resume(xPos); // resume the ring animation on drag end
			},
		});

		function getBgPos(i) {
			//returns the background-position string to create parallax movement in each image
			return (
				(-gsap.utils.wrap(0, 360, gsap.getProperty(ring, 'rotationY') - 180 - i * 36) / 360) * 400 + 'px 0px'
			);
		}


		window.onload = function() {
			function delayedFunction() {
				 document.querySelector('.ring').style.visibility = 'visible';
			}
			delayedFunction();
		 }
		}
	}
